import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MxImageCarouselComponent} from "./components/mx-image-carousel/mx-image-carousel.component";
import {MxSharedModule} from '../../shared/mx-shared.module';

@NgModule({
    declarations: [MxImageCarouselComponent],
    imports: [CommonModule, MxSharedModule],
    exports: [MxImageCarouselComponent],
})
export class MxCarouselModule {}
